import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordEconomics() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/economics-26"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>Principles of Austrian Economics</h3>
        <p className="story-text">
          <p className="story-text">
            This section introduces the foundational principles of Austrian economics. At its core, this school of thought studies human action and explains how the free market emerges as a natural consequence of individual choice, voluntary exchange, and personal responsibility. Rather than viewing markets as abstract mechanisms, Austrian economics emphasizes the role of human intention, incentives, and subjective value in shaping economic outcomes.
<br/><br/>
It is important to clarify that I do not necessarily agree with every belief or philosophical assumption found in Austrian economic thought, particularly those encountered outside the scope of the curriculum curated here. This section is not intended to promote Austrian economics as an ideology, but rather to present its analytical tools and insights where they are beneficial and relevant.
<br/><br/>
Studying this science equips a Muslim with a clearer understanding of how prices are formed, how individuals exercise free will in commercial activity, and how markets function when exchanges are voluntary and decentralized. These concepts are especially valuable when examined alongside the Islamic legal maxim that <i>all economic transactions are permissible unless there is clear evidence forbidding them</i>. When approached critically and within the framework of Islamic legislation, Austrian economics can serve as a useful lens for understanding real-world economic behavior.

<br/><br/>This section draws primarily from Economics in One Lesson by Henry Hazlitt, Human Action by Ludwig von Mises, and The Wealth of Nations by Adam Smith, along with relevant contributions from contemporary economists. These works are referenced for their economic insights rather than as comprehensive worldviews.

Many principles of Austrian economics such as decentralized markets, voluntary exchange, and individual agency closely align with the foundational principles of Bitcoin. Understanding these ideas will therefore assist the learner in appreciating why Bitcoin functions as it does and how it differs fundamentally from centrally planned monetary systems.
         <br/><br/> The learner receives a badge at both the beginning and the
            completion of this section. The term “graduate” is purely figurative
            and is used only to congratulate the learner and gamify the learning
            process.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity. </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordEconomics;
